"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseTwigJson = exports.getLanguage = exports.getErrorMessage = void 0;
var getErrorMessage = function (xhr) {
    if (xhr.responseJSON !== undefined &&
        xhr.responseJSON.error !== undefined &&
        xhr.responseJSON.error.message !== undefined) {
        return xhr.responseJSON.error.message;
    }
    return 'Something went wrong';
};
exports.getErrorMessage = getErrorMessage;
var getLanguage = function (languageId) {
    return (lang_to_id[languageId] || {
        name: 'Unknown',
        lang_iso: 'xx',
        lang_cc_iso: 'xx',
    });
};
exports.getLanguage = getLanguage;
/**
 * Depending on whether the Twig template was rendered in BE or dynamically
 * on the frontend, it uses different encoding for JSON.
 * This function normalizes this encoding and returns parsed JSON object.
 */
// eslint-disable-next-line import/prefer-default-export
var parseTwigJson = function (jsonString) {
    try {
        return JSON.parse(jsonString);
    }
    catch (e) {
        var parsedJson = new DOMParser().parseFromString(jsonString, 'text/html').documentElement.textContent;
        return JSON.parse(parsedJson !== null && parsedJson !== void 0 ? parsedJson : '');
    }
};
exports.parseTwigJson = parseTwigJson;
